import { map } from "lodash";
import axios from "src/utils/axios";
import { createSlice } from "@reduxjs/toolkit";

// Fase 3 · Sin `faker` (1,9 MB en el bundle inicial por este perfil de demo).
import { getImgCover, getImgFeed, getImgAvatar } from "src/utils/getImages";
import { isValidRestauranteId } from "src/utils/utils";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  myProfile: null,
  posts: [],
  users: [],
  user: null,
  userList: [],
  followers: [],
  friends: [],
  gallery: [],
  cards: null,
  addressBook: [],
  invoices: [],
  notifications: null,
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PROFILE
    getProfileSuccess(state, action) {
      state.isLoading = false;
      state.myProfile = action.payload;
    },

    // GET POSTS
    getPostsSuccess(state, action) {
      state.isLoading = false;
      state.posts = action.payload;
    },

    // GET USERS
    getUsersSuccess(state, action) {
      state.isLoading = false;
      state.users = action.payload;
    },

    // GET FOLLOWERS
    getFollowersSuccess(state, action) {
      state.isLoading = false;
      state.followers = action.payload;
    },

    // ON TOGGLE FOLLOW
    onToggleFollow(state, action) {
      const followerId = action.payload;

      const handleToggle = map(state.followers, (follower) => {
        if (follower.id === followerId) {
          return {
            ...follower,
            isFollowed: !follower.isFollowed,
          };
        }
        return follower;
      });

      state.followers = handleToggle;
    },

    // GET FRIENDS
    getFriendsSuccess(state, action) {
      state.isLoading = false;
      state.friends = action.payload;
    },

    // GET GALLERY
    getGallerySuccess(state, action) {
      state.isLoading = false;
      state.gallery = action.payload;
    },

    // GET MANAGE USERS
    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.userList = action.payload;
    },

    // GET CARDS
    getCardsSuccess(state, action) {
      state.isLoading = false;
      state.cards = action.payload;
    },

    // GET ADDRESS BOOK
    getAddressBookSuccess(state, action) {
      state.isLoading = false;
      state.addressBook = action.payload;
    },

    // GET INVOICES
    getInvoicesSuccess(state, action) {
      state.isLoading = false;
      state.invoices = action.payload;
    },

    // GET NOTIFICATIONS
    getNotificationsSuccess(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
    },
    getUserSuccess(state, action) {
      state.user = state.users.find((user) => user.id === action.payload);
      state.startLoading = false;
    },
    getUser(state, action) {
      state.user = action.payload;
      state.startLoading = false;
    },
    setUserSuccess(state, action) {
      state.user = action.payload;
      state.startLoading = false;
    },
    deleteUser(state, action) {
      state.users = state.users.map((u) => {
        if (u.id === action.payload) {
          u.isActive = !u.isActive;
        }
        return u;
      });
    },
    cleanUser(state, action) {
      state.user = null;
    },
    addUserSuccess(state, action) {
      state.users.push(action.payload);
    },
    updateUserSuccess(state, action) {
      state.users = state.users.map((u) => {
        if (u.id === action.payload.id) {
          return action.payload;
        }
        return u;
      });
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  onToggleFollow,
  getUserSuccess,
  setUserSuccess,
  cleanUser,
  addUserSuccess,
  updateUserSuccess,
} = slice.actions;

// ----------------------------------------------------------------------
const createId = (index) => `fc68bad5-d430-4033-b8f8-4bc069dc0ba0-${index}`;

export function getProfile() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const fakeRequest = () => {
        const profile = {
          id: createId(1),
          cover: {
            small: getImgCover(720, 1),
            medium: getImgCover(1200, 1),
          },
          position: "UI Designer",
          follower: 0,
          following: 0,
          quote:
            "Tart I love sugar plum I love oat cake. Sweet roll caramels I love jujubes. Topping cake wafer..",
          country: "España",
          email: "demo@takemyorder.es",
          company: "Take My Order",
          school: "Take My Order",
          facebookLink: `https://www.facebook.com/caitlyn.kerluke`,
          instagramLink: `https://www.instagram.com/caitlyn.kerluke`,
          linkedinLink: `https://www.linkedin.com/in/caitlyn.kerluke`,
          twitterLink: `https://www.twitter.com/caitlyn.kerluke`,
        };

        return [200, { profile }];
      };
      const response = fakeRequest();
      dispatch(slice.actions.getProfileSuccess(response.data.profile));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getPosts() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/posts");
      dispatch(slice.actions.getPostsSuccess(response.data.posts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFollowers() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/social/followers");
      dispatch(slice.actions.getFollowersSuccess(response.data.followers));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getFriends() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/social/friends");
      dispatch(slice.actions.getFriendsSuccess(response.data.friends));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getGallery() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/social/gallery");
      dispatch(slice.actions.getGallerySuccess(response.data.gallery));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUserList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/manage-users");
      dispatch(slice.actions.getUserListSuccess(response.data.users));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCards() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/account/cards");
      dispatch(slice.actions.getCardsSuccess(response.data.cards));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getAddressBook() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/account/address-book");
      dispatch(slice.actions.getAddressBookSuccess(response.data.addressBook));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getInvoices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/api/user/account/invoices");
      dispatch(slice.actions.getInvoicesSuccess(response.data.invoices));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getNotifications() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        "/api/user/account/notifications-settings",
      );
      dispatch(
        slice.actions.getNotificationsSuccess(response.data.notifications),
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUsers() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get("/authentication/getLicences");
      dispatch(slice.actions.getUsersSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteUser(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.deleteUser(id));
      await axios.delete(`/authentication/${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function duplicateUser(id, body) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      var response = await axios.post(`/authentication/clone/${id}`, body);
      dispatch(slice.actions.addUserSuccess(response.data));
    } catch (error) {
      console.error("Error duplicating user:", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUser(idRestaurante) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      var restaurantId = isValidRestauranteId(idRestaurante);

      if (!restaurantId) return;

      const response = await axios.get(
        `authentication/public/user/${idRestaurante}`,
      );
      dispatch(slice.actions.setUserSuccess(response.data.user));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function sendContactForm(messageInfo) {
  return async (dispatch) => {
    try {
      // let userId = window.localStorage.getItem('userId');
      let userId = 0;
      const response = await axios.post(`contactForm`, {
        ...messageInfo,
        userId: userId,
      });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
